/**
 * USER TOKENS STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    page: {},
    user_token: null,
    user_tokens: null,
};

// getters
const getters = {
    user_token_loader: (state) => (id) => {
        alert(id);
        return state.user_token_loader;
    },
    user_token: (state) => {
        return state.user_token;
    },
    user_tokens: (state) => {
        return state.user_tokens;
    },
};

// actions
const actions = {
    async fetchUserTokens({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitUserToken", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitUserToken", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateUserToken", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitUserToken(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateUserToken(state, payload) {
        if (payload.method == "post" && payload.with) {
            if (state[payload.property] == null) state[payload.property] = [];
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetUserTokens(state) {
        state.page = {};
        state.user_token = null;
        state.user_tokens = null;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
